import dayjs from 'dayjs';
import { z } from 'zod';

export const organizationEventSchema = z
  .object({
    id: z.number(),
    title: z.string(),
    start_at: z.string(),
    folder_path: z.array(z.string()).nullable().optional(),
  })
  .transform((raw) => ({
    id: raw.id,
    title: raw.title,
    startAt: dayjs(raw.start_at).format('D MMMM'),
    folderPath: raw.folder_path ?? [],
  }));

export const organizationSchema = z
  .object({
    id: z.number(),
    name: z.string(),
    description: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    events: z.array(organizationEventSchema).nullable().optional(),
  })
  .transform((raw) => {
    return {
      id: raw.id,
      name: raw.name,
      description: raw.description,
      createdAt: raw.created_at,
      updatedAt: raw.updated_at,
      events: raw.events ?? [],
    };
  });

export type OrganizationEvent = z.infer<typeof organizationEventSchema>;
export type OrganizationEntityApi = z.input<typeof organizationSchema>;
export type OrganizationEntity = z.infer<typeof organizationSchema>;

export const organizationsResponseSchema = z.object({
  items: z.array(organizationSchema),
  total: z.number(),
});

export type OrganizationsResponseApi = z.input<typeof organizationsResponseSchema>;
export type OrganizationsResponse = z.infer<typeof organizationsResponseSchema>;
